import { emitAll2ll41gkd5meqr as emitAll } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  Builder16nv925388a0q as Builder,
  ApolloResponse1aeginapbuksm as ApolloResponse,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Companion_getInstance1ji65oeucwbu1 as Companion_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3kr54qc67slio as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { delayko55i6ibvfeo as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { waitForNetwork1iyjlqng9xqa9 as waitForNetwork } from '../network/NetworkMonitor.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { flow3tazazxj2t7g4 as flow } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { onEach13yrgg7fxnyl6 as onEach } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Transform.mjs';
import { retryWhenf2aqzvtrvxoo as retryWhen } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Errors.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  OfflineException_getInstance26hqn5ntn4qci as OfflineException_getInstance,
} from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_OfflineApolloException() {
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  return OfflineApolloException;
}
var OfflineApolloException;
function RetryOnErrorInterceptor() {
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  return new (DefaultRetryOnErrorInterceptorImpl())(null);
}
function *_generator_invoke__zhh2q8($this, $this$flow, $completion) {
  var tmp;
  if ($this.a65_1) {
    var tmp0_safe_receiver = $this.b65_1.z64_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e65();
    tmp = (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.s3()) === false;
  } else {
    tmp = false;
  }
  if (tmp) {
    var tmp_0 = $this$flow.s1d(Builder().q43($this.c65_1.s42_1, $this.c65_1.t42_1).v43(get_OfflineApolloException()).c37(), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  } else {
    var tmp_1 = emitAll($this$flow, $this.d65_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $this$retryWhen, cause, _unused_var__etf5q3, $completion) {
  var tmp;
  if (cause instanceof RetryException()) {
    var _unary__edvuaz = $this.f65_1._v;
    $this.f65_1._v = _unary__edvuaz + 1 | 0;
    if (!($this.g65_1.z64_1 == null)) {
      var tmp_0 = waitForNetwork($this.g65_1.z64_1, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
    } else {
      Companion_getInstance();
      // Inline function 'kotlin.math.pow' call
      var n = $this.f65_1._v;
      // Inline function 'kotlin.time.Companion.seconds' call
      var this_0 = Math.pow(2.0, n);
      var tmp$ret$1 = toDuration(this_0, DurationUnit_SECONDS_getInstance());
      var tmp_1 = delay(tmp$ret$1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
    tmp = true;
  } else {
    tmp = false;
  }
  return tmp;
}
var DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass;
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda() {
  if (DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass === VOID) {
    class $ {
      constructor($failFastIfOffline, this$0, $request, $downStream) {
        this.a65_1 = $failFastIfOffline;
        this.b65_1 = this$0;
        this.c65_1 = $request;
        this.d65_1 = $downStream;
      }
      h65($this$flow, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$flow), $completion);
      }
      ud(p1, $completion) {
        return this.h65((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass = $;
  }
  return DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass;
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_0($failFastIfOffline, this$0, $request, $downStream) {
  var i = new (DefaultRetryOnErrorInterceptorImpl$intercept$slambda())($failFastIfOffline, this$0, $request, $downStream);
  var l = ($this$flow, $completion) => i.h65($this$flow, $completion);
  l.$arity = 1;
  return l;
}
var DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0;
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_1() {
  if (DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0 === VOID) {
    class $ {
      constructor($retryOnError, $attempt) {
        this.i65_1 = $retryOnError;
        this.j65_1 = $attempt;
      }
      i61(it, $completion) {
        if (this.i65_1 && !(it.c44_1 == null) && isRecoverable(ensureNotNull(it.c44_1))) {
          throw RetryException_getInstance();
        } else {
          this.j65_1._v = 0;
        }
        return Unit_instance;
      }
      ud(p1, $completion) {
        return this.i61(p1 instanceof ApolloResponse() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0 = $;
  }
  return DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_0;
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_2($retryOnError, $attempt) {
  var i = new (DefaultRetryOnErrorInterceptorImpl$intercept$slambda_1())($retryOnError, $attempt);
  var l = (it, $completion) => i.i61(it, $completion);
  l.$arity = 1;
  return l;
}
var DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1;
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_3() {
  if (DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1 === VOID) {
    class $ {
      constructor($attempt, this$0) {
        this.f65_1 = $attempt;
        this.g65_1 = this$0;
      }
      k65($this$retryWhen, cause, _unused_var__etf5q3, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$retryWhen, cause, _unused_var__etf5q3), $completion);
      }
      x5r(p1, p2, p3, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        var tmp_0 = p2 instanceof Error ? p2 : THROW_CCE();
        return this.k65(tmp, tmp_0, (!(p3 == null) ? typeof p3 === 'bigint' : false) ? p3 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [3]);
    DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1 = $;
  }
  return DefaultRetryOnErrorInterceptorImpl$intercept$slambdaClass_1;
}
function DefaultRetryOnErrorInterceptorImpl$intercept$slambda_4($attempt, this$0) {
  var i = new (DefaultRetryOnErrorInterceptorImpl$intercept$slambda_3())($attempt, this$0);
  var l = ($this$retryWhen, cause, _unused_var__etf5q3, $completion) => i.k65($this$retryWhen, cause, _unused_var__etf5q3, $completion);
  l.$arity = 3;
  return l;
}
var DefaultRetryOnErrorInterceptorImplClass;
function DefaultRetryOnErrorInterceptorImpl() {
  if (DefaultRetryOnErrorInterceptorImplClass === VOID) {
    class $ {
      constructor(networkMonitor) {
        this.z64_1 = networkMonitor;
      }
      v64(request, chain) {
        var tmp0_elvis_lhs = request.d43_1;
        var failFastIfOffline = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
        var tmp1_elvis_lhs = request.c43_1;
        var retryOnError = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
        if (!failFastIfOffline && !retryOnError) {
          return chain.u64(request);
        }
        var attempt = {_v: 0};
        var downStream = chain.u64(request);
        var tmp = flow(DefaultRetryOnErrorInterceptorImpl$intercept$slambda_0(failFastIfOffline, this, request, downStream));
        var tmp_0 = onEach(tmp, DefaultRetryOnErrorInterceptorImpl$intercept$slambda_2(retryOnError, attempt));
        return retryWhen(tmp_0, DefaultRetryOnErrorInterceptorImpl$intercept$slambda_4(attempt, this));
      }
    }
    initMetadataForClass($, 'DefaultRetryOnErrorInterceptorImpl');
    DefaultRetryOnErrorInterceptorImplClass = $;
  }
  return DefaultRetryOnErrorInterceptorImplClass;
}
function isRecoverable(_this__u8e3s4) {
  _init_properties_RetryOnErrorInterceptor_kt__m47hbi();
  return _this__u8e3s4 instanceof ApolloNetworkException();
}
var RetryExceptionClass;
function RetryException() {
  if (RetryExceptionClass === VOID) {
    class $ extends Exception() {
      static n65() {
        RetryException_instance = null;
        var $this = this.ce();
        RetryException_instance = $this;
        captureStack($this, $this.m65_1);
        return $this;
      }
    }
    initMetadataForObject($, 'RetryException');
    RetryExceptionClass = $;
  }
  return RetryExceptionClass;
}
var RetryException_instance;
function RetryException_getInstance() {
  if (RetryException_instance === VOID)
    RetryException().n65();
  return RetryException_instance;
}
var properties_initialized_RetryOnErrorInterceptor_kt_exnoek;
function _init_properties_RetryOnErrorInterceptor_kt__m47hbi() {
  if (!properties_initialized_RetryOnErrorInterceptor_kt_exnoek) {
    properties_initialized_RetryOnErrorInterceptor_kt_exnoek = true;
    OfflineApolloException = ApolloNetworkException().d47('The device is offline', OfflineException_getInstance());
  }
}
//region block: exports
export {
  RetryOnErrorInterceptor as RetryOnErrorInterceptor28nn2rq891clj,
};
//endregion

//# sourceMappingURL=RetryOnErrorInterceptor.mjs.map
